import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-flex items-center">
              <img
                src="/Logo.svg"
                alt="E-omi Services"
                className="navbar-logo"
                style={{
                  filter: 'brightness(0) invert(1)',
                  height: 'clamp(2rem, 4vw, 2.5rem)',
                  width: 'auto',
                  maxWidth: 'clamp(120px, 20vw, 180px)'
                }}
                onError={(e) => {
                  const el = e.target;
                  const candidates = ['/logo.svg', '/images/logo.svg', '/Group.svg', '/images/Group.svg'];
                  const idx = parseInt(el.dataset.fallbackIndex || '0', 10);
                  if (idx < candidates.length) {
                    el.dataset.fallbackIndex = String(idx + 1);
                    el.src = candidates[idx];
                  } else {
                    el.style.display = 'none';
                    if (el.nextSibling) {
                      el.nextSibling.style.display = 'block';
                    }
                  }
                }}
              />
              <span className="sr-only">E-omi Services</span>
            </Link>
            <p className="mt-4 text-gray-400">
              Solutions professionnelles de nettoyage pour entreprises
            </p>
          </div>

          {/* Liens Rapides */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="hover:text-white transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors duration-300">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors duration-300">
                  Devis Gratuit
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a href="tel:+33660886451" className="hover:text-white transition-colors duration-300">
                  +33 6 60 88 64 51
                </a>
              </li>
              <li>
                <a href="mailto:Contact@e-omiservices.fr" className="hover:text-white transition-colors duration-300">
                  Contact@e-omiservices.fr
                </a>
              </li>
              <li>Île-de-France</li>
            </ul>
          </div>
        </div>
        {/* Réseaux sociaux */}
        <div className="flex space-x-4">
              <a href="https://www.instagram.com/e.omiservices/" className="text-gray-400 hover:text-white transition-colors duration-300">
                Instagram
              </a>
            </div>

        {/* Ligne de séparation */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Copyright */}
            <div className="text-sm text-gray-400">
              © {currentYear} E-omi Services. Tous droits réservés.
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 